/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export interface accuWeatherStore {
  // TODO: any -> type (non-trivial)
  accuWeatherData: any;
  accuWeatherDataLoading: boolean;
  accuWeatherDataError: boolean;
  skipQuery: boolean;
  setAccuWeatherData: (data: any, loading: boolean, error: unknown, fallbackData: unknown) => void;
}

const initialState: accuWeatherStore = {
  accuWeatherData: null,
  accuWeatherDataLoading: true,
  accuWeatherDataError: false,
  skipQuery: false,
  setAccuWeatherData: () => {},
};

const AccuWeatherStore: StateCreator<accuWeatherStore> = set => {
  return {
    ...initialState,
    setAccuWeatherData: (data, loading, error, fallbackData) => {
      if (error) {
        console.log(fallbackData);
        set({ accuWeatherData: null, accuWeatherDataLoading: loading, accuWeatherDataError: true, skipQuery: true });
      } else if (data && Object.keys(data).length) {
        set({
          accuWeatherData: { ...data },
          accuWeatherDataLoading: loading,
          accuWeatherDataError: false,
          skipQuery: true,
        });
      }
    },
  };
};

export const useAccuWeatherStore = createAppStore(AccuWeatherStore, {
  usePersistentStore: false,
});
